const ChooseClaimType = {
  selectClaimTypeLabel: "Please select a claim type",
  authoriseTreatment: {
    International: {
      icon: "icon-stethoscope-outline",
      heading: "Check cover for treatment",
      description:
      "Get authorisation for treatments or appointments that you need."
    },
    Any: {
      icon: "icon-stethoscope-outline",
      heading: "Authorise a treatment or appointment",
      description:
      "Get authorisation for treatments or appointments that you need."
    }
  },
  bank:{
  Add:{
    title:"Add bank details for us to pay you back",
    description:"We dont have any bank details to pay you any money you're due. If you'd like us to pay you directly to your bank, please add your bank details.",
  buttonText:"Add bank details"
  } ,
  Update:{
    title:"Are your bank details correct?",
    description:"When we need to pay you money, for example when we pay you back for a claim, we'll use these details. Are they correct? If so, start a claim.",
  descriptionupdate:"If you update these details, it won't change which account we collect payments from.",
    buttonText:"Update bank details"
  }   

  },
  claimBack: {
    International: {
      icon: "icon-hand-heart",
      heading: "Claim back for payments you've made",
      description:
        "Claim back your payments for medical treatment and appointments."
    },
    Any: {
      icon: "icon-hand-heart",
      heading: "Claim back for payments you've made",
      description:
        "Claim back your payments for medical treatment / appointments, dental, optical, or NHS cash benefit."
    }
  }
};

export default ChooseClaimType;
